import CommonFunction from '@/common/commonFunction';

import { defaultTaxRegisHistory } from './module-taxregishistory-state';

export default {
	resetState(state) {
		Object.assign(state, defaultTaxRegisHistory);
	},
	updateTaxReturnRegisHistory: function(state, res) {
		CommonFunction.genVKeyValue(res.Data);
		state.TaxReturnRegisHistoryData.removeAll();
		for (let index = 0; index < res.Data.length; index++) {
			res.Data[index].SerialNumber = index + 1;
		}
		state.TaxReturnRegisHistoryData.append(res.Data);
		state.Total = res.Total;
	},
	updateListHistoryRegister: function(state, res) {
		CommonFunction.genVKeyValue(res.Data);
		state.ListHistoryRegister.removeAll();
		state.ListHistoryRegister.append(res.Data);
		state.TotalHistoryRegister = res.Total;
	},
	appendTaxReturnRegisHistory: function(state, res) {
		CommonFunction.genVKeyValue(res.Data);
		state.TaxReturnRegisHistoryData.append(res.Data);
		state.Total = res.Total;
	}
};
